"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _propTypes = require("prop-types");
var _AvatarColorHelper = require("./AvatarColorHelper");
var _Avatar = require("./Avatar.styled");
var _uuid = require("uuid");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function getColorIdValue(user) {
  var fl = "".concat(user.firstName, " ").concat(user.lastName);
  var id = '';
  var lenLimit = 24;
  while (id.length < 24) {
    id = "".concat(id).concat(fl);
  }
  return id.substr(0, lenLimit);
}

/**
 * User Avatar
 */
var Avatar = exports.Avatar = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Avatar, _Component);
  var _super = _createSuper(Avatar);
  function Avatar(props) {
    (0, _classCallCheck2["default"])(this, Avatar);
    return _super.call(this, props);
  }
  (0, _createClass2["default"])(Avatar, [{
    key: "render",
    value: function render() {
      var _user$firstName, _user$lastName;
      var _this$props = this.props,
        user = _this$props.user,
        height = _this$props.height,
        width = _this$props.width,
        showColor = _this$props.showColor,
        hideTooltip = _this$props.hideTooltip,
        initialsFontSize = _this$props.initialsFontSize,
        backgroundColor = _this$props.backgroundColor;
      if (!user) return /*#__PURE__*/_react["default"].createElement("span", null);
      user.firstName = (_user$firstName = user.firstName) !== null && _user$firstName !== void 0 ? _user$firstName : '';
      user.lastName = (_user$lastName = user.lastName) !== null && _user$lastName !== void 0 ? _user$lastName : '';
      var userName = "".concat(user.firstName, " ").concat(user.lastName),
        type = user.type || null;
      var style;
      if (showColor) {
        var userRgb = (0, _AvatarColorHelper.getUserColor)(getColorIdValue(user));
        style = backgroundColor ? {
          backgroundColor: backgroundColor
        } : {
          backgroundColor: "rgb(".concat(userRgb.r, ",").concat(userRgb.g, ",").concat(userRgb.b, ")")
        };
      }
      var userInitials = "".concat(user.firstName.charAt(0).toUpperCase()).concat(user.lastName.charAt(0).toUpperCase());
      var altText = "Avatar for ".concat(user.firstName, " ").concat(user.lastName);
      altText = "".concat(altText, " in color background");
      var tipTargetId = "user_avatar_".concat((0, _uuid.v4)());
      var avatar = /*#__PURE__*/_react["default"].createElement(_Avatar.AvatarWrapper, {
        className: "dd-privacy-mask",
        key: tipTargetId,
        style: _objectSpread(_objectSpread({}, style), {}, {
          width: width,
          height: height
        }),
        id: tipTargetId
      }, /*#__PURE__*/_react["default"].createElement(_Avatar.ContentWrapper, {
        title: "".concat(altText),
        style: {
          width: width,
          height: height,
          fontSize: initialsFontSize
        },
        "data-testid": "user-avatar-content-wrapper"
      }, userInitials), type === 'editing' ? /*#__PURE__*/_react["default"].createElement(_Avatar.UserEditing, {
        style: style
      }) : null);
      if (hideTooltip) return avatar;
      return [avatar, /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
        className: "dd-privacy-mask",
        key: "".concat(tipTargetId, "-tooltip"),
        placement: "top",
        target: tipTargetId
      }, "".concat(userName, " ").concat(type === 'editing' ? 'is editing...' : ''))];
    }
  }]);
  return Avatar;
}(_react.Component);
(0, _defineProperty2["default"])(Avatar, "defaultProps", {
  hideTooltip: false,
  height: _Avatar.DefaultAvatarSize,
  width: _Avatar.DefaultAvatarSize,
  showColor: true,
  initialsFontSize: '16px'
});
Avatar.propTypes = {
  user: _propTypes.PropTypes.object,
  hideTooltip: _propTypes.PropTypes.bool,
  height: _propTypes.PropTypes.string,
  width: _propTypes.PropTypes.string,
  showColor: _propTypes.PropTypes.bool,
  initialsFontSize: _propTypes.PropTypes.string,
  backgroundColor: _propTypes.PropTypes.string
};